import React from "react"
import Keypad from "./Keypad"

function MyCalc() {
    return(
        <div className="calculator">
            <Keypad />
        </div>
    )
}
export default MyCalc